import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FleetRoutingModule } from './fleet-routing.module';
import { FleetComponent } from './fleet.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FilterListModule } from '../filterlist/filterlist.module';
import { VehicleModule } from './vehicle/vehicle.module';
import { AngularMaterialModule } from '../shared/module/angular-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';
import { VehicleDetailModule } from './vehicle-detail/vehicle-detail.module';
import { ScheduleModule } from './schedule/schedule.module';
import { ScheduleDetailModule } from './schedule-detail/schedule-detail.module';
import { DynamicTableModule } from '../dynamic-table/dynamic-table.module';
import { GoogleMapsModule } from '@angular/google-maps';
import { TranslateModule } from '@ngx-translate/core';
import { ApplicationPipesModule } from 'src/app/shared/module/applicationPipesModule';
import { MotorComponent } from 'src/app/fleet/motor/motor.component';
import { DvirModule } from './dvir-detail/dvir-detail.module';

@NgModule({
    declarations: [FleetComponent, MotorComponent ],
    imports: [
        CommonModule,
        VehicleModule,
        VehicleDetailModule,
        ScheduleModule,
        ScheduleDetailModule,
        FleetRoutingModule,
        MatPaginatorModule,
        FilterListModule,
        AngularMaterialModule,
        ReactiveFormsModule,
        FormsModule,
        MatSliderModule,
        DynamicTableModule,
        GoogleMapsModule,
        TranslateModule.forChild(),
        ApplicationPipesModule,
        DvirModule
    ]
})
export class FleetModule { }
